const directive = () => {
    return {
        inserted: (el, bindings) => {
            if (!bindings.value) return;

            //console.log('adding listener', el);
            el.addEventListener('keydown', e => {
                if (e.keyCode == 13 && !e.repeat)
                {
                    bindings.value();
                }
            })
        }
    }
}

export default directive();